module.exports = __webpack_public_path__ + "static/media/reading.75b1d52e.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/reading.png
// module id = 948
// module chunks = 0